export const promptTemplateConstants = {
    GET_PROMPT_TEMPLATE_REQUEST: 'GET_PROMPT_TEMPLATE_REQUEST',
    GET_PROMPT_TEMPLATE_SUCCESS: 'GET_PROMPT_TEMPLATE_SUCCESS',
    GET_PROMPT_TEMPLATE_FAILURE: 'GET_PROMPT_TEMPLATE_FAILURE',

    UPDATE_PROMPT_TEMPLATE_REQUEST: 'UPDATE_PROMPT_TEMPLATE_REQUEST',
    UPDATE_PROMPT_TEMPLATE_SUCCESS: 'UPDATE_PROMPT_TEMPLATE_SUCCESS',
    UPDATE_PROMPT_TEMPLATE_FAILURE: 'UPDATE_PROMPT_TEMPLATE_FAILURE',
};